module.exports = __webpack_public_path__ + "assets/img/5_1383_big.91794a90.jpg";